import { createContext, useContext, useState } from 'react'

import _ from 'lodash'

const ModalContext = createContext()

export const useModalContext = () => useContext(ModalContext)

export const ModalProvider = ({ children }) => {
  const [_showModal, _setShowModal] = useState(false)
  const [contextProps, setContextProps] = useState({})

  const showModal = props => {
    if (props?.dontReplaceIfOpen && _showModal) return
    _setShowModal(props)

    setContextProps(
      props && _.isObject(props) && Object.keys(props).length > 0
        ? _.omit(props, ['component', 'onHide', 'onSave'])
        : {}
    )
  }
  const hideModal = () => showModal(false)

  const Modal = ({ component, onHide, onSave, ...rest }) => {
    const Component = component

    return (
      <Component
        {...rest}
        show={_showModal}
        onHide={() => {
          hideModal()
          onHide && onHide()
        }}
        onSave={record => {
          hideModal()
          onSave && onSave(record)
        }}
      />
    )
  }

  return (
    <ModalContext.Provider
      value={{
        ...contextProps,

        modalIsOpen: !!_showModal,
        showModal,
        hideModal
      }}
    >
      {children}
      {_showModal && <Modal {..._showModal} />}
    </ModalContext.Provider>
  )
}

export const withModal = Component => {
  const WrappedComponent = props => {
    return (
      <ModalProvider>
        <Component {...props} />
      </ModalProvider>
    )
  }

  WrappedComponent.displayName = `withModal(${
    Component.displayName || Component.name
  })`

  return WrappedComponent
}
